import * as _ from 'lodash';

import { CURRENCY_LIST } from './currency-list';
import { CurrencyModel } from './currency.model';


export default class CurrencyCodeMapper {

  public static getName(code: string): string {
    const currency = this.findBy('code', code);
    return currency ? currency.name : '';
  }

  public static getCode(name: string): string {
    const currency = this.findBy('name', name);
    return currency ? currency.code : '';
  }

  public static getCurrencyList(): CurrencyModel[] {
    return CURRENCY_LIST;
  }

  public static getNames(): string[] {
    return _.map(CURRENCY_LIST, (currency: CurrencyModel) => currency.name);
  }

  public static getCodes(): string[] {
    return _.map(CURRENCY_LIST, (currency: CurrencyModel) => currency.code);
  }

  public static findBy(property: string, value: string): CurrencyModel | undefined {
    return _.find(CURRENCY_LIST, (currency: CurrencyModel) => (<any>currency)[property] === value);
  }

}
